import { type Till } from "~/api/tills/types";

export function getTerminalId(till: Till) {
  if (till.paymentGatewayConfig?.provider === "freedompay") {
    return till.freedompayTerminalId;
  }

  return till.terminalId;
}
